import leadStoryAPI from 'media-base-ui/utils/leadStoryAPI';
import actionCreators from './actionCreators';

const fetchLeadStoryData = () => async dispatch => {
    dispatch(actionCreators.requestLeadStory());

    try {
        const data = await leadStoryAPI.fetchLeadStoryData();
        const leadStoryData = data => data.data[0].videoId !== 0
            ? Object.assign({}, data.data[0], {videoToggled: false})
            : data.data[0];

        dispatch(actionCreators.leadStoryResponse(true, leadStoryData(data), []));
    } catch (error) {
        dispatch(actionCreators.leadStoryResponse(false, [], null, error))
    }
};

export default {
    fetchLeadStoryData
};
